import Button from "components/button/Button";
import IconButton from "components/button/IconButton";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import { IoMdRefresh } from "react-icons/io";
import { IoFunnel } from "react-icons/io5";
import { BiSolidMessageDetail } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  createBtn?: {
    title: string;
    handler: () => void;
    icon?: ReactNode;
    loading?: boolean;
  };
  filterBtn?: {
    title: string;
    handler: () => void;
  };
  secondaryButton?: {
    title: string;
    handler: () => void;
    icon?: ReactNode;
    loading?: boolean;
  };
  refreshBtn?: () => void;
  showBack?: boolean;
};

const HeaderBox = ({
  title,
  createBtn,
  secondaryButton,
  filterBtn,
  refreshBtn,
  showBack,
}: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="mb-4 mt-2 flex w-full flex-wrap items-center justify-between gap-4">
      <div className="flex min-h-[50px] items-center gap-3">
        {showBack && (
          <IconButton
            handler={() => navigate(-1)}
            title={t("buttons.back")}
            icon={<FaArrowRight />}
            className="rotate-180 rtl:rotate-0"
          />
        )}
        <h4
          className="text-lg font-semibold text-gray-800 dark:text-white/90"
          x-text="pageName"
        >
          {title}
        </h4>
        {refreshBtn && (
          <IconButton
            handler={refreshBtn}
            title={t("buttons.refresh")}
            icon={<IoMdRefresh size={22} />}
            size="md"
          />
        )}
      </div>

      <div className="flex gap-2">
        {filterBtn && (
          <Button
            onClick={filterBtn?.handler}
            size="sm"
            className="md:hidden"
            startIcon={<IoFunnel />}
          >
            {filterBtn?.title}
          </Button>
        )}
        {secondaryButton && (
          <Button
            size="sm"
            variant="info"
            onClick={secondaryButton?.handler}
            loading={secondaryButton?.loading}
            startIcon={secondaryButton.icon || <BiSolidMessageDetail />}
          >
            {secondaryButton?.title}
          </Button>
        )}
        {createBtn && (
          <Button
            size="sm"
            onClick={createBtn?.handler}
            loading={createBtn?.loading}
            startIcon={createBtn.icon || <FaCirclePlus />}
          >
            {createBtn?.title}
          </Button>
        )}
      </div>
    </div>
  );
};

export default HeaderBox;
